export enum OneClickOrigin {
    CALCULADORA = 3
}
export enum OriginPayment {
    INT = 2
}
export enum SourceShoppingCart {
    NEW_CART = 4,
    CART_V3 = 5
}

export enum methodsName {
    PAYPAL = 'paypal',
    DINERO_MAIL = 'dinero_mail',
    CARD = 'tarjeta',
    CASH = 'efectivo',
    TRANSFER = 'transferencia',
    CARD_3DS = 'card_3ds',
    DIRECT = 'pago_directo',
    MERCADOPAGO = 'mercadopago',
}

export const payment_method: any = {
    [methodsName.PAYPAL]: 1,
    [methodsName.DINERO_MAIL]: 2,
    [methodsName.CARD]: 3,
    [methodsName.TRANSFER]: 4,
    [methodsName.CARD_3DS]: 5,
    [methodsName.CASH]: 6,
    [methodsName.DIRECT]: 8,
    [methodsName.MERCADOPAGO]: 9,
};

export const pyament_method_str = {
    [methodsName.PAYPAL]: "Paypal",
    [methodsName.DINERO_MAIL]: "Dinero Mail",
    [methodsName.CARD]: "Tarjeta",
    [methodsName.TRANSFER]: "Transferencia Bancaria",
    [methodsName.CARD_3DS]: "Tarjeta 3DS",
    [methodsName.CASH]: "Pago en Tienda",
    [methodsName.DIRECT]: "Pago directo",
    [methodsName.MERCADOPAGO]: "Mercado Pago",
};

/** Total del carrito (MXN) por encima del cual Tarjeta no aplica. */
export const PAYMENT_MAX_AMOUNT_CARD_MXN = 150000;

/** Total del carrito (MXN) por encima del cual Pago en tienda no aplica. */
export const PAYMENT_MAX_AMOUNT_STORE_MXN = 30000;

export const PAYMENT_METHOD_LIMIT_EXCEEDED_MESSAGE_CARD =
    'Método de pago no disponible para cantidades mayores o iguales a $150,000.00 MXN';

export const PAYMENT_METHOD_LIMIT_EXCEEDED_MESSAGE_STORE =
    'Método de pago no disponible para cantidades mayores o iguales a $30,000.00 MXN';

export function getMaxAmountForPaymentMethod(methodValue: number): number | null {
    if (methodValue === payment_method[methodsName.CARD]) return PAYMENT_MAX_AMOUNT_CARD_MXN;
    if (methodValue === payment_method[methodsName.CASH]) return PAYMENT_MAX_AMOUNT_STORE_MXN;
    if (methodValue === payment_method[methodsName.MERCADOPAGO]) return PAYMENT_MAX_AMOUNT_CARD_MXN;
    return null;
}

/** true si el método elegido no puede usarse con ese total (tarjeta / tienda y total > límite). */
export function isPaymentMethodDisallowedForTotal(methodValue: number | null, total: number): boolean {
    if (methodValue === null) return false;
    const maxAmount = getMaxAmountForPaymentMethod(methodValue);
    if (maxAmount === null) return false;
    return total > maxAmount;
}

export function getPaymentMethodLimitExceededMessage(methodValue: number | null): string {
    if (methodValue === payment_method[methodsName.CASH]) {
        return PAYMENT_METHOD_LIMIT_EXCEEDED_MESSAGE_STORE;
    }
    return PAYMENT_METHOD_LIMIT_EXCEEDED_MESSAGE_CARD;
}

/** Pasarela de pago (gateway) — nivel 1 del selector de pago en cascada. */
export enum paymentGateway {
    MERCADOPAGO = 'mercadopago',
    OPENPAY = 'openpay',
    PAYPAL = 'paypal',
    PAGO_DIRECTO = 'pago_directo',
}

/** Forma de pago disponible dentro de una pasarela — nivel 2 del selector en cascada. */
export interface PaymentGatewayForma {
    value: number;
    label: string;
}

/** Configuración de pasarela → formas de pago disponibles (nivel 1 → nivel 2 del selector en cascada). */
export interface PaymentGatewayConfig {
    gateway: paymentGateway;
    label: string;
    formas: PaymentGatewayForma[];
    /** Solo presente en pasarelas terminales (sin nivel 2): fija el payment_method directamente. */
    terminalPaymentMethod?: number;
}

/** Pasarelas de pago en el orden de presentación del selector en cascada. */
export const PAYMENT_GATEWAYS: PaymentGatewayConfig[] = [
    {
        gateway: paymentGateway.MERCADOPAGO,
        label: 'MercadoPago',
        formas: [{ value: payment_method[methodsName.MERCADOPAGO], label: 'Link' }],
    },
    {
        gateway: paymentGateway.OPENPAY,
        label: 'OpenPay',
        formas: [
            { value: payment_method[methodsName.CARD], label: pyament_method_str[methodsName.CARD] },
            { value: payment_method[methodsName.TRANSFER], label: pyament_method_str[methodsName.TRANSFER] },
            { value: payment_method[methodsName.CASH], label: pyament_method_str[methodsName.CASH] },
        ],
    },
    {
        gateway: paymentGateway.PAYPAL,
        label: 'Paypal',
        formas: [{ value: payment_method[methodsName.PAYPAL], label: 'Tarjeta' }],
    },
    {
        gateway: paymentGateway.PAGO_DIRECTO,
        label: 'Pago Directo (PCOM)',
        formas: [],
        terminalPaymentMethod: payment_method[methodsName.DIRECT],
    },
];
